"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _httpClient = _interopRequireDefault(require("../httpClient"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _default = {
  createContact: function createContact(contactType, _ref) {
    var memberId = _ref.memberId,
        serviceProviderId = _ref.serviceProviderId,
        contextEntityId = _ref.contextEntityId,
        oneTimeToken = _ref.oneTimeToken;
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    _httpClient.default.post("/gateway/analytics/v1/contact/service-provider/".concat(serviceProviderId), {
      headers: _objectSpread(_objectSpread({}, !(0, _isUndefined2.default)(oneTimeToken) && {
        Authorization: 'OneTime ' + oneTimeToken
      }), {}, {
        'X-ANGI-CallerId': serviceProviderId
      }),
      body: {
        contacts: [{
          contactType: contactType,
          contextEntityId: +contextEntityId,
          memberUserId: +memberId,
          occurrenceTimestamp: new Date()
        }]
      }
    });

    callback();
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/contactAnalyticsProvider.js
// module id = 862
// module chunks = 25